import { Grid, Stack, useTheme } from "@mui/material";
import Modal from "components/Common/Modal";
import React from "react";
import { isMobile } from "react-device-detect";
import sanitizeHtml from "utils/sanitizeHtml";

const LetterOfConfirmation: React.FC<{
  body: string | TrustedHTML;
  open: boolean;
  isLoading?: boolean;
  onClose: () => void;
  action?: () => void;
}> = ({ body, open, isLoading, onClose, action }) => {
  const theme = useTheme();
  const modalOverlaySx = {
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2ch",
    padding: "2ch",
    fontSize: `${theme.typography.fontSize}px !important`,
    fontFamily: `${theme.typography.fontFamily} !important`,
    height: "inherit !important",
    fontWeight: "inherit !important",
  };
  const modalSx = {
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    "&:focus-visible": {
      outline: "none",
    },
  };
  return (
    <Modal
      message={
        <Grid item xs={12}>
          <Stack
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(String(body ?? "")),
            }}
            margin="auto"
          />
        </Grid>
      }
      sx={modalSx}
      width={isMobile ? "90%" : "40%"}
      height="80vh"
      open={open}
      modalOverlaySx={modalOverlaySx}
      modalFooterSx={{ maxWidth: "100%" }}
      onClose={onClose}
      closeButton
      modalContentSx={{ padding: "8px !important" }}
      modalHeaderSx={{ backgroundColor: "transparent" }}
      primary={{
        children: "I Sign",
        onClick: action,
        loading: isLoading,
      }}
    />
  );
};

export default LetterOfConfirmation;
